$(document).ready(function () {
    $('.shopSlider_for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.shopSlider_nav',
        responsive: [
            {
                breakpoint: 577,
                settings: {
                    arrows: false,
                }
            }
        ]
    });
    $('.shopSlider_nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.shopSlider_for',
        arrows: false,
        dots: false,
        focusOnSelect: true,
        variableWidth: true
    });

    // $('.brandsSlider').slick({
    //     slidesToShow: 4,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     dots: true,
    //     infinite: true,
    //     // autoplay: true,
    //     autoplaySpeed: 3000,
    //     speed: 300,
    //     // variableWidth: true,
    //     responsive: [
    //         {
    //             breakpoint: 769,
    //             settings: {
    //                 slidesToShow: 3,
    //             }
    //         },
    //         {
    //             breakpoint: 577,
    //             settings: {
    //                 slidesToShow: 2,
    //             }
    //         }
    //     ]
    // });

    // слайдер Swiper - бренды в магазине
    const shopBrandsSlider = new Swiper('.shopDetail .shopBrandsSlider', {
        // Optional parameters
        loop: true,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        spaceBetween: 20,

        // Pagination
        pagination: {
            el: '.shopDetail .shopBrandsSliderWrap .swiper-pagination',
            clickable: true,
        },

        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            300: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 3,
            },
            800: {
                slidesPerView: 4,
            },
        },
    });
});
